import { render, staticRenderFns } from "./CurrencyJustified.vue?vue&type=template&id=f6a011be&scoped=true&"
import script from "./CurrencyJustified.vue?vue&type=script&lang=js&"
export * from "./CurrencyJustified.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyJustified.vue?vue&type=style&index=0&id=f6a011be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a011be",
  null
  
)

export default component.exports